import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CTASection from './components/CTASection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import KnowledgeBase from './components/KnowledgeBase';
import SEOArticlesSection from './components/SEOArticlesSection';
import TestimonialsSection from './components/TestimonialsSection';

const SITE_URL = typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL
  ? import.meta.env.VITE_SITE_URL
  : 'https://itaobuyspread.store';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CTASection />
        <CategoryGrid />
        <AboutSection />
        <KnowledgeBase />
        <SEOArticlesSection />
        <TestimonialsSection />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebSite',
              name: 'Itaobuy Spreadsheet Italia',
              url: SITE_URL,
              description: 'La guida italiana definitiva per itaobuy spreadsheet e lo shopping intelligente.',
              inLanguage: 'it-IT',
              publisher: {
                '@type': 'Organization',
                name: 'Itaobuy Spreadsheet Italia',
                url: SITE_URL,
              },
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Organization',
              name: 'Itaobuy Spreadsheet Italia',
              url: SITE_URL,
              description: 'Piattaforma italiana di guide allo shopping con itaobuy spreadsheet.',
            }),
          }}
        />
      </main>
      <Footer />
    </>
  );
}